const module = {
  namespaced: true,
  state: () => ({
    eventType: '',
    timestamp: '',
  }),
  mutations: {
    setEventType(state, eventType) {
      state.eventType = eventType;
      state.timestamp = Date.now();
    },
  },
};

export default module;
